import axios from 'axios'
import { useEffect, useState } from 'react'
import Header from '../components/header'
import FoodElement from '../components/outputFoodElement'
import '../home.scss'

type foodData = {
    food_id:string,
    name:string,
    quantity:number,
    limit_at:string,
    thumbnail_url:string
}

const Refrigerator = () =>{
    const [foodEmpty,setFoodBool] = useState<Boolean>(true)
    const [foods,setFoods] = useState<Array<foodData>>([]);
    async function componentDidMount() {

    }
    const getIsEmptyOfRefrigerator = () =>{
        console.log(foods.length)
        if (foods.length === 0){
            setFoodBool(true)
            console.log(foodEmpty)
        }else{
            setFoodBool(false)
            console.log(foodEmpty)
        }
    }
    useEffect(() =>{
        async function getFoodsOfRefrigerator(){
            console.log(document.cookie)
            const BaseURL = "https://mega-api-web.azurewebsites.net/api/v1/foods"
            const res =await axios.get<[]>(BaseURL,
                {
                    headers:{
                        "Content-type":"application/json",
                        "jwt-token": "Bearer "+document.cookie
                    }
                })
                if(res.status == 200){
                    console.log(res.data)
                    setFoods(res.data)
                }else{
                    console.log(res.status)
                }
        }
        getFoodsOfRefrigerator();
        getIsEmptyOfRefrigerator();
    },[])
    // const getFoodsOfRefrigerator = async() =>{

    // }


    if (foodEmpty){
        return(
            <div>
            <Header/>
                {foods.map((food,index) => (
                    <ul className='grid grid-cols-3'>
                    <a key ={index} className='bg-red-200 rounded-lg m-4 py-4 px-4'>
                            <FoodElement
                                name= {food.name}
                                quantity={food.quantity}
                                foodLossLimit={food.limit_at}
                                imagePath={food.thumbnail_url}
                            ></FoodElement>
                    </a>
                    </ul>
                ))}
            </div>
        )
    }else{
    return(
        <>
        <Header/>
                <div className='grid grid-rows-2 text-center'>
                    <div className='text-2xl pt-16 text-purple-300'>冷蔵庫の中身がないよ</div>
                    <div>
                        <div className='container'>
                            <p className='bound'>
                                <span className='text-2xl'>(´・ω・｀)</span>
                            </p>
                        </div>
                    </div>
                </div>
        </>

    )
    }
}
export default Refrigerator